import React from 'react';
import { Stack, Typography, List } from '@mui/material';
import PageContainer from 'pages/PageContainer';
import { ConsentProcessingLists } from 'shared/constants/legal-pages-constants/consent-processing-constants';
import { HomeLink } from 'components/LegalPagesLinks/HomeLink';
import { MailToLink } from 'components/LegalPagesLinks/MailToLink';
import { CustomListItem } from 'components/List/CustomListItem/CustomListItem';
import CustomLink from 'components/CustomLink/CustomLink';
import { urls } from 'shared/constants/routing.constants';

const ConsentToDataProcessing: React.FunctionComponent = () => (
  <PageContainer showMenu={false}>
    <Stack py={{ xs: 0, md: 4 }} rowGap="64px" width="100%" maxWidth="1200px" mx="auto">
      <Stack rowGap="16px">
        <Typography variant="h1">Consent to Data Processing</Typography>
        <Typography variant="body2">Effective Date: March 13, 2026 • Version 1.1</Typography>

        <Typography variant="body2">
          {'By using the '}
          <HomeLink />
          {` platform operated by Deb8.TV (“we,” “our,” or “us”), 
             you consent to the collection, use, and processing of your personal data as described in our `}
          <CustomLink
            href={urls.commonPages.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              textDecoration: 'underline',
              fontSize: 'inherit',
              fontWeight: 'normal',
            }}
          >
            Privacy Policy
          </CustomLink>
          .
        </Typography>
        <Typography variant="body2" className="no-uppercase">
          Our Privacy Policy explains in detail:
        </Typography>
        <List className="list-legal-pages">
          {ConsentProcessingLists.map((item, index) => (
            <CustomListItem key={index} {...item} />
          ))}
        </List>
        <Typography variant="body2" className="no-uppercase">
          You have the right to withdraw your consent at any time by contacting us. Withdrawal of
          consent does not affect the lawfulness of processing carried out before withdrawal.
        </Typography>
        <Typography variant="body2" className="no-uppercase">
          If you do not agree with our data processing practices, please discontinue use of the
          platform.
        </Typography>
        <Typography variant="body2" className="no-uppercase">
          {'For questions or requests regarding data processing, contact us at '}
          <MailToLink />
        </Typography>
      </Stack>
    </Stack>
  </PageContainer>
);

export default ConsentToDataProcessing;
